import React, { useState } from 'react'

import * as R from 'ramda'

import { Box, Container, Flex } from 'stardust'

import DocumentCard from '~/components/DocumentCard'
import DocumentModalSelector from '~/components/DocumentModalSelector'

const findDocument = (documents, selectedDocId) => {
  return R.find(
    ({ id, type, typeId }) => id === selectedDocId || `${type}-${typeId}` === selectedDocId,
    documents
  )
}

const DocumentResults = ({ documents, selectedDocId }) => {
  const [selectedDoc, setSelectedDoc] = useState(() => findDocument(documents, selectedDocId))
  return (
    <>
      <Container>
        <Box px={5} ml="-16px">
          <Flex flexWrap="wrap">
            {documents.map((doc) => (
              <DocumentCard
                key={doc.id}
                onClick={() => setSelectedDoc(doc)}
                coverImage={doc.coverImage}
                id={doc.typeId}
                isPublished={doc.status === 'published'}
                thumbImage={doc.coverImage}
                title={doc.title}
                type={doc.type}
              />
            ))}
          </Flex>
        </Box>
      </Container>
      <DocumentModalSelector document={selectedDoc} onClose={() => setSelectedDoc(null)} />
    </>
  )
}

DocumentResults.displayName = 'DocumentResults'

export default DocumentResults
